import { useMemo } from "react";
import { subMonths, addMonths } from "date-fns";

// hooks
import useMLSCalendarMatches from "./useMLSCalendarMatches";

function useCalendarDots({
    seasonSportecId,
    competitionSportecId,
    clubSportecId,
    activeMonth
}) {
    const { prevMonth, currentMonth, nextMonth } = useMemo(() => {
        const prevMonth = subMonths(activeMonth, 1);
        const currentMonth = activeMonth;
        const nextMonth = addMonths(activeMonth, 1);

        return { prevMonth, currentMonth, nextMonth };
    }, [activeMonth]);


    const { data: currentMonthMatches } = useMLSCalendarMatches({
        seasonSportecId,
        competitionSportecId,
        clubSportecId,
        activeMonth: currentMonth,
    });

    const { data: prevMonthMatches } = useMLSCalendarMatches({
        seasonSportecId,
        competitionSportecId,
        clubSportecId,
        activeMonth: prevMonth,
    });

    const { data: nextMonthMatches } = useMLSCalendarMatches({
        seasonSportecId,
        competitionSportecId,
        clubSportecId,
        activeMonth: nextMonth,
    });

    return {
        currentMonthMatches,
        prevMonthMatches,
        nextMonthMatches,
        allMonthsMatches: new Map([...(prevMonthMatches || []), ...(currentMonthMatches || []), ...(nextMonthMatches || [])]),
    };
}

export default useCalendarDots;